import { OverlayTrigger, Popover } from "react-bootstrap";

function Tooltip({ text }) {
  const popover = (
    <Popover id="popover-basic">
      <Popover.Body>{text}</Popover.Body>
    </Popover>
  );

  return (
    <div className="progress-wrapper">
      <OverlayTrigger placement="bottom-start" overlay={popover}>
        <i
          className="bi bi-info-circle px-2"
          data-bs-toggle="tooltip"
          data-bs-placement="bottom"
          title="Tooltip on top"
          template='<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'
        ></i>
      </OverlayTrigger>
    </div>
  );
}

export default Tooltip;
